export default "__VITE_ASSET__MYPlqONO__"